<p-scrollPanel [style]="{ width: '100%', height: '100%' }">
  <form [formGroup]="form.formGroup" class="h-full min-h-0 flex flex-col pr-1">
    <div class="mb-2 flex flex-col">
      <div class="flex items-center space-x-1">
        <label for="name">Name:</label>
        @if (isAltus) {
          <p-button
            text
            icon="pi pi-copy"
            size="small"
            severity="success"
            pTooltip="Copy Fluid ID (Altus only)"
            (click)="copyFluidId()"
          ></p-button>
        }
      </div>

      <input
        id="fluid-name"
        type="text"
        pInputText
        [formControlName]="form.formControlNames.name"
      />
    </div>

    @if (fluids && userUnits) {
      <div class="flex-1 min-h-0 flex flex-col">
        @switch (form.formGroup.value.type) {
          @case (FluidType.STANDARDMUD) {
            <app-standard-muds
              [isReadOnly]="isReadOnly"
              [formControlName]="form.formControlNames.standardMud"
              [userUnits]="userUnits"
            ></app-standard-muds>
          }
          @case (FluidType.BRINE) {
            <app-brines
              [isReadOnly]="isReadOnly"
              [formControlName]="form.formControlNames.brine"
              [userUnits]="userUnits"
              [selectedBrineType]="form.formGroup.controls.brine.value.brineType"
              [isInUse]="isFluidInUse"
              [changeTrigger]="changeTrigger"
            ></app-brines>
          }
          @case (FluidType.BLACKOIL) {
            <app-black-oil
              [isReadOnly]="isReadOnly"
              [formControlName]="form.formControlNames.blackOil"
              [changeTrigger]="changeTrigger"
            ></app-black-oil>
          }
          @case (FluidType.BASEOIL) {
            <app-base-oils
              [formControlName]="form.formControlNames.baseOil"
            ></app-base-oils>
          }
          @case (FluidType.CEMENTSLURRY) {
            <app-cement-slurries
              [formControlName]="form.formControlNames.cementSlurry"
              [userUnits]="userUnits"
              [fluidsStore]="fluidsStore"
              class="block min-h-0"
            ></app-cement-slurries>
          }
          @case (FluidType.VLE) {
            <app-vle
              [formControlName]="form.formControlNames.vle"
            ></app-vle>
          }
          @case (FluidType.ADVANCEDMUD) {
            <app-advanced-muds
              [isReadOnly]="isReadOnly"
              [formControlName]="form.formControlNames.advancedMud"
              [fluids]="fluids"
              [userUnits]="userUnits"
            ></app-advanced-muds>
          }
          @case (FluidType.CO2FLUID) {
            <app-co2-fluid
              [isReadOnly]="isReadOnly"
              [formControlName]="form.formControlNames.co2Fluid"
              [isPureCo2]="isPureCo2"
              [co2ChangeTrigger]="co2ChangeTrigger"
              [phaseEnvelopeCalculated]="phaseEnvelopeCalculated"
              [userUnits]="userUnits"
              [fluidsStore]="fluidsStore"
              [hideGergCalc]="hideGergCalc"
              class="block h-full min-h-0"
            ></app-co2-fluid>
          }
          @case (FluidType.POLYMER) {
            <app-polymers
              [isReadOnly]="isReadOnly"
              [formControlName]="form.formControlNames.polymer"
              [userUnits]="userUnits"
              [fluidsStore]="fluidsStore"
              [fuidChangeTrigger]="co2ChangeTrigger"
              [isInUse]="isFluidInUse"
              class="block min-h-0"
            ></app-polymers>
          }
        }
      </div>
    }
  </form>
</p-scrollPanel>